import Head from "next/head";
import { DeclarationScript } from "~/utils/cookieBot";
import { useRef } from "react";
import SingleType from "../SingleType";

export default function CookiesPage() {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <SingleType>
      <Head>
        <title>Butik Danmark - Cookies</title>
        <meta
          name="description"
          content="Alt det gode danske håndværk - samlet ét sted"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <h1 className="uppercase text-3xl mt-20 mb-2 font-bold antialiased tracking-widest text-center">
        Sådan bruger vi cookies
      </h1>
      <SingleType.Content>
        <div className="text-base text-neutral-500" ref={ref}>
          <DeclarationScript parentRef={ref} />
        </div>
      </SingleType.Content>
    </SingleType>
  );
}
